
import Vue from 'vue'

export default Vue.extend({
  name: 'anyAPIKeyName',
  props: {
    value: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  }
})
